import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/products/:id',
  title: 'title',
  endpoint: '/app/store_product',
}
